export const en = {
    index: {
        header_1: 'What ',
        header_2: 'type of Storage',
        header_3: ' do you require?',
        select_option: 'Select an option to proceed',
        skip_button_text: 'Skip - Show me all prices',
        personal: 'Personal',
        business: 'Business',
        personalText: 'Store personal items, keepsakes and small furniture',
        businessText: 'Secure storage for business inventory, documents and equipment',
    },
    journey_bar: {
        step_1: 'Storage Type',
        step_2: 'Storage Size',
        step_3_a: 'Pricing',
        step_3_b: 'Booking',
        step_4: 'Confirm',
        step_5: 'Payment',
        step_6: 'Summary',
    },
    unit_listing: {
        header_1: 'How much ',
        header_2: 'space',
        header_3: ' do you require?',
        no_units: 'No Units',
        unit_unavailable_at_move_in: 'The unit is no longer available. Please select another unit to continue.',
    },
    book_unit: {
        header_1: 'Select a ',
        header_2: 'deal',
        header_3: ' below',
        deals: ' deals',
        inclusions: "What's Included",
        click_to_view: 'Click to view',
    },
    customise_booking: {
        header_mobile: 'Select Options',
        upgrade: 'Upgrade',
    },
    descriptor: {
        idealFor: 'Ideal For',
    },
    carousel: {
        smaller: 'Smaller',
        larger: 'Larger',
    },
    stack: {
        inclusions: "What's Included",
    },
    labels: {
        small: 'SMALL',
        medium: 'MEDIUM',
        large: 'LARGE',
        or: 'Or',
        easiest_access: 'Easiest Access',
    },
    time: {
        per_week: 'Per Week',
        per_month: 'Per Month',
    },
    sizeSlider: {
        small: 'Small',
        medium: 'Medium',
        large: 'Large',
    },
    cta: {
        select: 'Select',
        continue: 'Continue',
        step_3: {
            continue: 'Continue',
        },
        enquire_now: 'Enquire Now',
        call_us_now: 'Call Us Now',
        cancel: 'Cancel',
        close: 'Close',
        bigger_unit: 'Need a bigger unit?',
        email_us: 'Email Us',
        call_us: 'Call Us',
    },
    unit_card: {
        no_price_chane: 'No Price Change',
        valued_at: 'Valued at',
        customise_booking: 'Customise Booking',
        alternative_unit_options: 'Alternative Unit Options',
        no_units_available: 'No units available',
        extra: 'Extra',
        save: 'Save',
    },
    coupon_code: {
        title: 'Promo Code / Coupon',
        apply: 'Apply',
        placeholder: 'Enter your promo or coupon code here',
        alerts: {
            success: 'Promo code applied successfully',
            error: 'Promo code expired or invalid',
        },
    },
    contact_card: {
        error: 'Error',
        error_text:
            'An error has occured while submitting the form. Please try again or contact our site if this problem persists',
        phone: 'Phone',
        email: 'Email',
        first_name: 'First Name',
        last_name: 'Last Name',
        email_address: 'Email Address',
        move_in_date: 'Move In Date',
        phone_number: 'Phone Number',
        address: 'Address',
        postcode: 'Postcode',
        city: 'City',
        state: 'State',
        reservation: {
            title: 'Reservation',
            subtitle:
                'Almost there! We just need a few more things to finalise your reservation.',
            success: 'Reserved!',
            success_detail: 'Thank you, your reservation has been successfully created.',
        },
        quote: {
            title: 'Quote Details',
            subtitle:
                'Almost there! We just need a few more things then your personalised quote will be emailed to you.',
            success: 'Quote Sent!',
            success_detail: 'Thank you, your quote has been sent to your inbox.',
        },
        showPrices: {
            title: 'Show Prices',
            form_title: 'Show Prices',
            submit_text: 'Show Prices',
            subtitle:
                'Almost there! We just need a couple more details to provide you with a personalised quote.',
        },
        contactMe: {
            title: 'Enquire Now',
            submit_text: 'Enquire Now'
        }
    },
    wizard: {
        back: 'Back',
        reservation: 'Reservation',
        scheduleMoveIn: 'Schedule your move-in',
        copy: 'This reservation requires a fee to be paid. Please proceed through the steps to complete your reservation. During the process we will reserve a storage unit for you and send you an email with the details.',
        selectDate: 'Select a date you would like to move-in.',
        next: 'Next',
        confirm_booking: 'Confirm Booking',
        payViaFinverse: 'Pay via Finverse',
        process_paypal: 'Pay via PayPal',
        termsAndConditionsAgree: 'I agree to the terms and conditions',
        marketingAgree: 'Allow marketing',
        dateOfBirth: 'Date of Birth',
        otherError:
            'An unexpected error has occurred, please refresh and try again or contact support',
        autobill: 'Auto bill my card to avoid late fees',
        autobillDetails: {
            title: 'Autobill',
            directDebit: 'Direct Debit',
            creditCard: 'Credit Card',
            bsbNumber: 'BSB Number',
            accountNumber: 'Account Number',
            none: 'None',
            switchToDebit: '',
        },
        personal: 'Personal',
        business: 'Business',
        contactDetails: {
            title: 'Contact Details',
            titles: {
                mr: 'Mr',
                mrs: 'Mrs',
                miss: 'Miss',
                ms: 'Ms',
                dr: 'Dr',
            },
            commercial:
                'Please enter your company name and company registration number. You must be authorised to act on behalf of the company.',
            company: 'Company Name',
            companyNumber: 'Company Registration Number',
        },
        alternateContactDetails: {
            title: 'Alternate Contact Details',
            subtitle:
                'This information allows us to contact someone if we are unable to contact you.',
        },
        accountDetails: {
            title: 'Account Details',
            copy: 'Must be 8 to 20 characters in length, contain at least one uppercase and lowercase character and at least one number. This password will allow you to login and pay your account online after move-in.',
            password: 'Online Password',
            confirmPassword: 'Confirm Online Password',
        },
        reservationWithFee: {
            orderNumber: 'Order Number: ',
            confirmationText:
                'We’ve sent you an email with all the details of your order & remember you can track your order using this app.',
        },
        reservationConfirmed: {
            title: 'Reservation Confirmed',
            subtitle:
                'You will receive an email with your reservation details.',
            finaliseBooking: 'Finalise Booking Now',
        },
        insuranceCoverage: {
            title: 'Insurance Coverage',
            subtitle:
                'Insurance is not included with our rent charges. We highly recommend that all customers insure their goods for peace of mind.',
            coverage: 'Coverage',
            for_up_to: 'for up to ',
            noInsuranceSelected: 'No Insurance Selected',
            manualEntryLabel: 'Declared value of goods stored',
            disclaimer:
                "By ticking this box you accept and agree: that the insurance coverage option selected will cover the true replacement value of your goods declared, agree to the T&C's below and understand the inclusions/exclusions of the policy.",
            flatRateInsurance: 'Flat Rate Insurance',
            selfInsurance: 'Self Insurance',
            usSupply: 'Select this option if you would like US to supply insurance.',
            subTitle: 'Select this option if YOU will supply insurance',
            proofDisclaimer:
                'Note: you will need to upload Proof of Insurance below to complete your booking',
            fileTypePlease:
                'Please upload either a jpg, png or pdf file using the Proof of Insurance section below.',
            pickerText:
                ''
        },
        addressProof: {
            title: 'Proof of Address',
            subtitle:
                'Upload documentation showing a proof of the address you have provided',
            fileUploadHelpText:
                'Please upload a photo which has proof of your current address. Examples are bank statements, credit card statements or utility bills.',
            uploading: 'Uploading...',
            success: 'File uploaded successfully',
            error: 'Error uploading file',
        },
        insuranceProof: {
            title: 'Proof of Insurance',
            subtitle:
                'Upload documentation showing a proof of insurance taken out for your declared amount',
            fileUploadHelpText: 'A passport style (head & shoulder) photo of yourself.',
            uploading: 'Uploading...',
            success: 'File uploaded successfully',
            error: 'Error uploading file',
        },
        boxShop: {
            title: 'Moving & Packing Supplies',
            outOfStock: 'Out of stock',
            pickUpLocation: 'Pickup Location',
            showAll: 'Show All',
            showLess: 'Show Less',
        },
        pricingTable: {
            title: 'Booking Summary',
            charge: 'Charge',
            amount: 'Amount',
            discount: 'Discount',
            initialAmount: 'Initial Amount',
            subtotal: 'Subtotal',
            tax: 'Tax',
            total: 'Total',
            including: "including"
        },
        identityVerification: {
            title: 'Identity Verification',
            driverLicenseDetails: 'Driver License Details',
            uploadDriverLicense: 'Driver License',
            fileUploadHelpText:
                'Please upload a photo of the FRONT of your drivers license or passport photo in JPG, PNG or PDF file',
            idDocumentNumber: 'ID Document Number',
        },
        paymentForm: {
            title: 'Payment',
            errors: {
                cardHolderInvalid: 'Card Holder Name is invalid',
                cardNumberInvalid: 'Card Number is invalid',
                cardExpiryInvalid: 'Card Expiry is invalid',
                cardCsvInvalid: 'Card CSV is invalid',
            },
        },
        bookingConfirmation: {
            title: 'Thank you for your booking',
            subtitle:
                'We have sent you an email with more details, please refer to the email for further information.',
            referenceCode: 'Your reference code is: ',
            autobillError: 'Your move-in was successful, but there was an issue with your autopayment details. Please contact support.',
            merchPaymentError: 'Your move-in was successful, but there was an issue with your merchandise. Please contact support.',
            insuranceError: 'Your move-in was successful, but there was an issue assigning your insurance. Please contact support.',
            customerSurvey: {
                title: 'Customer Survey',
                subtitle:
                    'We really value our customer feedback and would love if you answer some quick questions below!',
                submit: 'Submit Survey',
            },
            idVerifyButtonText: 'Verify ID',
            idVerifyText: 'Please verify your ID using the button below. Alterntatively you can do this later in the app.',
        },
        marketingSurvey: {
            title: 'Customer Survey',
            subtitle:
                'Help us improve our services by answering the following questions:',
            Marketing: 'Where did you hear about us?',
            MktgDistance: 'Distance from facility?',
            MktgWhy: 'Why are you storing?',
            MktgType: 'Which best describes you?',
            MktgWhat: 'What are you storing?',
            MktgReason: 'What reason are you storing with us?',
            submit: 'Submit Survey',
            defaultOption: 'Please select an option',
        },
        termsAndConditions: 'Terms and Conditions',
    },
    error: {
        oops: 'Oops! Something went wrong',
        subtitle: 'Sorry, an unexpected error has occured.',
        general_error: 'A general error has occured, please try again or contact support',
        go_back: 'Go back',
        not_found:
            'The page you requested could not be found, please check you may have mistyped the address or the page may have moved.',
        move_in_error:
            'There has been an issue with the move in process, please contact support if this issue persists.',
    },
    map: {
        map: 'Map',
        booking: 'Booking',
        smaller: 'Smaller',
        bigger: 'Bigger',
        select_unit: 'Select a unit below',
        booking_card: {
            title: 'YOUR BOOKING DETAILS',
            deals: 'FACILITY DISCOUNTS & DEALS',
            select_a_deal: 'Select a deal to apply to your booking',
            different_unit: 'Select a different unit type or standard below.',
            change_size: 'Change Size',
        }
    },
    errors: {
        10000: 'An error occurred, please try again later.',
        10001: 'Unit is already rented or is no longer available.',
        50716: 'Transaction Declined. 3D Secure Authentication Failed',
    }
};
